module.exports = __webpack_public_path__ + "img/sle.ddbd1d9b.svg";